'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var modifierTotal = function modifierTotal(modifier) {
  return _lodash2.default.sum(modifier.items.map(function (item) {
    return item.price || 0;
  }));
};

var itemPrice = function itemPrice(item) {
  if (!item.modifiers) return item.price;

  var modifiersSum = _lodash2.default.sum(item.modifiers.map(modifierTotal));
  return item.price + modifiersSum;
};

var extraCostCreate = function extraCostCreate(label, amount, type) {
  return {
    label: label,
    amount: amount,
    type: type
  };
};

var extraCostFromVoucher = function extraCostFromVoucher(voucher, cartItems) {
  var amount = void 0,
      type = void 0;
  switch (voucher.discount.format) {
    case _constants.VOUCHER_FORMAT_FREE_ITEM:
      amount = 0;
      type = _constants.EXTRA_COST_TYPE_NEUTRAL;
      break;
    case _constants.VOUCHER_FORMAT_PERCENTAGE:
      amount = voucher.discount.amount / 100 * subTotal(cartItems);
      type = _constants.EXTRA_COST_TYPE_NEGATIVE;
      break;
    case _constants.VOUCHER_FORMAT_ABSOLUTE:
      amount = voucher.discount.amount;
      type = _constants.EXTRA_COST_TYPE_NEGATIVE;
      break;
  }
  return extraCostCreate(voucher.message, Math.floor(amount), type);
};

var extraCostItem = function extraCostItem(item) {
  return (item.type === _constants.EXTRA_COST_TYPE_POSITIVE ? 1 : -1) * item.amount;
};

var subTotal = function subTotal(items) {
  return _lodash2.default.sum(items.map(itemPrice));
};

var extraCosts = function extraCosts(costs) {
  return _lodash2.default.sum(costs.map(extraCostItem));
};

var total = function total(items, costs) {
  return _lodash2.default.sum([subTotal(items || []), extraCosts(costs || [])]);
};

var hasItem = function hasItem(cart, item) {
  return _lodash2.default.some(cart, ['id', item.id]);
};

var serialize = function serialize(cart) {
  return _lodash2.default.map(cart, function (item) {
    return {
      id: item.id,
      price: item.price,
      modifiers: _lodash2.default.map(item.modifiers, function (m) {
        return {
          id: m.id,
          items: _lodash2.default.map(m.items, function (x) {
            return {
              id: x.id,
              price: x.price
            };
          })
        };
      })
    };
  });
};

var itemQuantity = function itemQuantity(cart, item) {
  return _lodash2.default.filter(cart, ['id', item.id]).length;
};

var isEmpty = function isEmpty(cart) {
  return cart.length === 0;
};

// spostato qua da merchant-lib/modules/orders/lib - valutare se rimuovere da la
var serializeItemKey = function serializeItemKey(item) {
  var key = item.id;

  (item.modifiers || []).forEach(function (modifier) {
    key = key + '_' + modifier.id;

    (modifier.items || []).forEach(function (modifierItem) {
      key = key + '_' + modifierItem.id;
    });
  });

  return key;
};

// spostato qua da merchant-lib/modules/orders/lib - rimuovere da la
var groupOrderItems = function groupOrderItems(items) {
  var map = {};

  var kv = items.reduce(function (acc, item) {
    var key = serializeItemKey(item);

    var quantity = 0;

    if (map[key] === undefined) {
      map[key] = Object.keys(acc).length;
    } else {
      quantity = acc[map[key]].quantity;
    }

    return _extends({}, acc, _defineProperty({}, map[key], _extends({}, item, {
      quantity: quantity + 1
    })));
  }, {});

  return _lodash2.default.values(kv);
};

exports.default = {
  modifierTotal: modifierTotal,
  itemPrice: itemPrice,
  subTotal: subTotal,
  total: total,
  hasItem: hasItem,
  itemQuantity: itemQuantity,
  isEmpty: isEmpty,
  serialize: serialize,
  extraCosts: extraCosts,
  extraCostCreate: extraCostCreate,
  extraCostFromVoucher: extraCostFromVoucher,
  groupOrderItems: groupOrderItems
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/~/@arreeba/ristoranti-lib/lib/cart.js
// module id = 51
// module chunks = 0